import dao from './ducks/dao';

export default dao.reducer;
